import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import Map from "../../pages/shops/map";

export default function Scheme() {
  const { data: shopIndex } = useSelector((state) => state.popup);
  const { contactsData } = useSelector((state) => state.contacts);

  return (
    <div className={styles.Wrapper}>
      <div>
        <h2>{contactsData.SHOPS[shopIndex].NAME}</h2>
        <Map shop={contactsData.SHOPS[shopIndex]} />
      </div>
    </div>
  );
}
